import { Component } from '@angular/core';

@Component({
  templateUrl: './welcome.html'  
})
export class WelcomeComponent { 

    constructor() {
      
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/welcome/welcome-component.ts